import Abstract from "../../abstract-view/abstract.js";

import {
  createElement
} from "../../render/render.js";

const createSuggestionItemTemplate = (content) => {
  return (
    `<li class="suggestions-list__item">
      <button class="suggestions-list__button" type="button" tabindex="0">${content}</button>
    </li>`
  );
};

export default class SuggestionItem extends Abstract {
  constructor(content) {
    super();

    this._content = content;

    this._buttonElement = null;

    this._buttonClickHandler = this._buttonClickHandler.bind(this);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  getButtonElement() {
    if (!this._buttonElement) {
      this._buttonElement = this._element.querySelector(`button`);
    }

    return this._buttonElement;
  }

  getButtonText() {
    return this.getButtonElement().textContent;
  }

  setButtonClickHandler(callback) {
    this._callback.buttonClick = callback;
    this.getButtonElement().addEventListener(`click`, this._buttonClickHandler);
  }

  _getTemplate() {
    return createSuggestionItemTemplate(this._content);
  }

  _buttonClickHandler() {
    this._callback.buttonClick(this.getButtonText());
  }
}
